import { render, staticRenderFns } from "./Setting_Rating.vue?vue&type=template&id=1e106274&scoped=true"
import script from "./Setting_Rating.vue?vue&type=script&lang=js"
export * from "./Setting_Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e106274",
  null
  
)

export default component.exports